import { useEffect, useState } from "react";
import { FiEdit3 } from "react-icons/fi";
import { MdArrowBack } from "react-icons/md";
import { useSelector } from "react-redux";
import { getFile } from "../../api/documentUpload";
import { getArticle } from "../../api/helpCenterApi";
import { FORMS, MODULES } from "../../const";
import LoadingSpinner from "../LoadingSpinner";
import logo_icon from "../../assets/cargotool-icon.png";

const HelpCenterCardDetailComponent = ({
  setSelectedKey,
  searchClicked,
  selectedCard,
  setEditMode,
  setArticleId,
  setSelectedCard,
  setUpdateNeeded,
  updateNeeded,
}) => {
  const auth = useSelector((state) => state.user.permissions[MODULES?.Master]);
  const helpCenterPermission = auth?.[FORMS?.HELP_CENTER?.HELP_CENTER?.form];
  console.log("helpCenterPermission", helpCenterPermission);
  const createArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.CREATE;
  const deleteArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.DELETE;
  const updateArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.UPDATE;
  const viewArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.VIEW;
  const [loading, setLoading] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    (async () => {
      if (updateNeeded) {
        setIsDataLoading(true);
        const response = await getArticle(selectedCard.articleId);
        setSelectedCard(response);
        setUpdateNeeded(false);
        setIsDataLoading(false);
      }
    })();
  }, [updateNeeded]);

  const handleBack = () => {
    if (searchClicked) {
      setSelectedKey(2); // back to search results
    } else {
      setSelectedKey(null); // back to home
    }
  };

  // Manage iframe loading
  useEffect(() => {
    setLoading(true);
  }, [selectedCard]);

  const previewFileFromDoc = async (doc) => {
    setIsLoading(true);
    try {
      const blob = await getFile(doc.docId);
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Preview failed", error);
    }
    setIsLoading(false);
  };

  const downloadFileFromDoc = async (doc) => {
    setIsDownloading(true);
    try {
      const blob = await getFile(doc.docId);
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = doc.docName;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
    }
    setIsDownloading(false);
  };

  console.log("viewArticlePermission", viewArticlePermission);

  return (
    <>
      {isLoading && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Loading ...`} />
        </div>
      )}
      {isDownloading && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Downloading ...`} />
        </div>
      )}
      {isDataLoading ? (
        <LoadingSpinner message="Loading article..." />
      ) : (
        <div className="help-center-sub-container">
          {/* Top bar */}
          <div className="help-center-sub-header">
            <div
              className="help-center-sub-logo-header"
              style={{
                position: "absolute",
                left: 20,
                top: 20,
                cursor: "pointer",
                zIndex: "1000",
              }}
            >
              <img
                src={logo_icon}
                alt="logo-icon"
                className="help-center-logo-icon"
              />
              <div className="help-center-logo">HELP CENTER</div>
            </div>
            <MdArrowBack
              color="black"
              size={30}
              className="help-back-icon"
              onClick={handleBack}
              style={{
                position: "absolute",
                right: 60,
                top: 20,
                cursor: "pointer",
                zIndex: "1000",
              }}
            />
            {updateArticlePermission && (
              <FiEdit3
                color="black"
                size={28}
                className="help-back-icon"
                onClick={() => {
                  setEditMode(true);
                  setArticleId(selectedCard.articleId);
                  setSelectedKey(3);
                }}
                style={{
                  position: "absolute",
                  right: 100,
                  top: 20,
                  cursor: "pointer",
                  zIndex: "1000",
                }}
              />
            )}
          </div>

          {/* Title */}
          {viewArticlePermission && (
            <div className="help-center-sub-title">
              <h3 className="sub-text-title">{selectedCard.title}</h3>
            </div>
          )}

          {/* Description */}
          {viewArticlePermission && (
            <div
              className="sub-text-des"
              dangerouslySetInnerHTML={{
                __html:
                  selectedCard.bodyHtml &&
                  selectedCard.bodyHtml.trim().length > 0
                    ? selectedCard.bodyHtml
                    : "<p>No description available.</p>",
              }}
            />
          )}

          {/* Documents Section */}
          {viewArticlePermission &&
            selectedCard.documents &&
            selectedCard.documents.length > 0 && (
              <div className="doc-container">
                <h4>Attached Documents</h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                  {selectedCard.documents.map((doc) => {
                    const url = `${process.env.REACT_APP_FILE_SERVER_URL}/${doc.docUrl}`;
                    const isImage =
                      doc.fileTypeValue?.toLowerCase().includes("PNG") ||
                      doc.fileTypeValue?.toLowerCase().includes("JPG") ||
                      doc.fileTypeValue?.toLowerCase().includes("JPEG");

                    return (
                      <div
                        key={doc.docId}
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: "10px",
                          textAlign: "center",
                          width: "150px",
                          cursor: "pointer",
                        }}
                        onDoubleClick={() => previewFileFromDoc(doc)}
                      >
                        {isImage ? (
                          <img
                            src={url}
                            alt={doc.docName}
                            style={{
                              width: "100%",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "4px",
                              fontSize: "12px",
                              padding: "5px",
                            }}
                          >
                            {doc.fileTypeValue || "File"}
                          </div>
                        )}
                        <p
                          style={{
                            fontSize: "12px",
                            margin: "8px 0 4px 0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={doc.docName}
                        >
                          {doc.docName}
                        </p>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            downloadFileFromDoc(doc);
                          }}
                          style={{
                            fontSize: "12px",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          Download
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

          {/* Video */}
          {viewArticlePermission && (
            <div
              className="help-center-video-wrapper"
              style={{ position: "relative" }}
            >
              {loading && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <LoadingSpinner message="Loading video..." />
                </div>
              )}

              {/* Generate a valid iframe HTML for YouTube or OneDrive */}
              {(() => {
                const url = selectedCard?.videoEmbedHtml || "";
                let embedHtml = url;

                // Convert normal YouTube links to embed iframe if needed
                const youtubeMatch = url.match(
                  /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/
                );

                if (youtubeMatch) {
                  const videoId = youtubeMatch[1];
                  embedHtml = `<iframe
                        height="600" 
                        src="https://www.youtube.com/embed/${videoId}"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        style="position:absolute; top:0; left:0; width:100%; height:600;"
                        allowfullscreen>
                      </iframe>`;
                }

                // Render the iframe HTML
                return (
                  <div
                    dangerouslySetInnerHTML={{ __html: embedHtml }}
                    style={{ display: loading ? "none" : "block" }}
                  />
                );
              })()}

              {/* Hidden iframe to detect load completion */}
              <iframe
                src={
                  selectedCard?.videoEmbedHtml?.includes("iframe")
                    ? ""
                    : selectedCard?.videoEmbedHtml
                }
                srcDoc={selectedCard?.videoEmbedHtml}
                style={{ display: "none" }}
                onLoad={() => setLoading(false)}
                title="iframe-loader-checker"
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default HelpCenterCardDetailComponent;

//  {viewArticlePermission && (
//               <div
//                 className="help-center-video-wrapper"
//                 style={{ position: "relative" }}
//               >
//                 {loading && (
//                   <div style={{ textAlign: "center", padding: "20px" }}>
//                     <LoadingSpinner message="Loading video..." />
//                   </div>
//                 )}
//                 <div
//                   dangerouslySetInnerHTML={{
//                     __html: selectedCard.videoEmbedHtml,
//                   }}
//                   style={{ display: loading ? "none" : "block" }}
//                 />
//                 {/* When iframe loads, hide the loader */}
//                 <iframe
//                   srcDoc={selectedCard.videoEmbedHtml}
//                   style={{ display: "none" }}
//                   onLoad={() => setLoading(false)}
//                   title="iframe-loader-checker"
//                 />
//               </div>
//           )}

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
